export class SDK {
    static get version() {
        return SDK._version.trim() || null;
    }
}
SDK.type = 'client';
SDK.headerKeys = Object.freeze({
    version: 'x-sdk-version',
    type: 'x-sdk-type',
});
// This variable is injected through the grunt build command,
// the empty string is set in case if version not provided.
//
// e.g: grunt build --sdk-version=v1.0.0
SDK._version = 'v1.103.1';
//# sourceMappingURL=../../src/lib/configs/sdk.js.map